import Alert from '@mui/material/Alert';
import DialogContent from '@mui/material/DialogContent';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField.tsx';
import { FormProvider, type UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { CreateApiKeyModalForm } from '../hooks/useCreateApiKeyModal.tsx';

type CreateApiKeyModalContentProps = {
  formMethods: UseFormReturn<CreateApiKeyModalForm>;
};

export const CreateApiKeyModalContent = ({ formMethods }: CreateApiKeyModalContentProps) => {
  const { t } = useTranslation();

  return (
    <DialogContent dividers>
      <Alert severity="info" data-test="create-api-key-alert">
        {t('Your generated API Key will expire in')} <b>{t('90 days.')}</b>{' '}
        {t('Make sure to use or renew it before then!')}
      </Alert>
      <FormProvider {...formMethods}>
        <RHFTextField
          label={t('API Key Name')}
          placeholder={t('Enter API Key Name')}
          fullWidth
          sx={{ mt: 2, mb: 2 }}
          name="apiKeyName"
          dataTest="api-key-name-field"
        />
      </FormProvider>
    </DialogContent>
  );
};
